<!--
Copyright 2020 Google LLC

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
-->
<template>
  <div class="sidebar-banner">
    <!-- /wheelrandom_com_300x250_sidebar_1 -->
    <div id='wheelrandom_com_300x250_sidebar_1'>
    </div>
    <div id='wheelrandom_com_300x250_sidebar_2' style="margin-top:10px;">
    </div>
    <div @click="close" id="sidebar-close">✕</div>
  </div>
</template>

<script>


export default {
  methods: {
    close() {
      document.getElementsByClassName("sidebar-banner")[0].style.display = "none";
    }
  },
  mounted() {
    if(window.innerWidth > 1400) {
      window.googletag.cmd.push(function() { googletag.display('wheelrandom_com_300x250_sidebar_1'); });
      window.googletag.cmd.push(function() { googletag.display('wheelrandom_com_300x250_sidebar_2'); });
    }
  }
}
</script>

<style scoped>
.sidebar-banner {
  background:#eeeeee;
  height: 600px;
  padding: 10px;
  position: relative;
  max-width: 320px;
}
@media (max-width: 1400px) {
  .sidebar-banner {
    display: none;
  }
}
#sidebar-close{
  background: #eeeeee;
  display: inline-block;
  content: "\00d7";
  position: absolute;
  right: -30px;
  font-size: 20px;
  z-index: 9999;
  width: 30px;
  text-align: center;
  top: 0;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
}
</style>
